// permissions-interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { PermissionService } from '../services/permission.service';

type ApiResponse<T = unknown> = {
  message?: string;
  data?: T;
  handlecode?: string | number;
  permissions?: string[] | null;
};

@Injectable()
export class PermissionsInterceptor implements HttpInterceptor {
  constructor(
      private perms: PermissionService
    ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const expectsJson = req.responseType === 'json' || req.responseType === undefined;

    return next.handle(req).pipe(
      tap(event => {
        if (!expectsJson) return;
        if (event instanceof HttpResponse) {
          const body = event.body as ApiResponse | null;

          if (body && typeof body === 'object') {
            if('permissions' in body){
              // console.log(body.permissions);
              this.perms.updateIfChanged(body.permissions ?? []);
            }
          }

        }
      })
    );
  }
}